<template>
  <v-dialog
    id="signin_modal"
    v-if="getDialog.signIn"
    v-model="getDialog.signIn"
    activator="parent"
    width="auto"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t("signIn.signInTitle") }}</h5>
        <button
          type="button"
          class="btn-close"
          @click="closeDialog()"
        ></button>
      </div>
      <div class="modal-body">
        <v-form class="login-form" ref="form" lazy-validation>
          <div class="form-box">
            <div class="form-group m-0">
              <v-text-field
                id="idField"
                v-model="idField"
                :rules="idRules"
                required
                :placeholder="$t('signIn.idPlaceholder')"
                autocomplete="off"
                @keydown.enter.prevent
              ></v-text-field>
            </div>
          </div>
          <div class="form-box password">
            <div class="form-group password" :class="pwdField ? 'active' : ''">
              <v-text-field
                id="pwdField"
                type="password"
                v-model="pwdField"
                :rules="pwdRules"
                required
                :placeholder="$t('signIn.pwPlaceholder')"
                autocomplete="off"
                @keydown.enter.prevent="handleLogin()"
              ></v-text-field>
            </div>
          </div>
        </v-form>
        <div class="login-button">
          <button class="login-btn" :disabled="disableBtn" @click="handleLogin()">
            {{ $t("signIn.signInTitle") }}
          </button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { AuthActions, AuthNamespace } from "@/store/auth";
import { mapActions, mapGetters } from "vuex";
import DialogMixin from "@/mixins/dialogMixin";
export default {
  mixins: [DialogMixin],
  data() {
    return {
      SignInDialog: false,
      inputOptions: {
        showDialCode: true,
        tabindex: 0,
      },
      // id, password input value 및 rules
      valid: false,
      idField: "",
      idRules: [(v) => !!v || this.$t("signIn.idEmptyRules")],
      pwdField: "",
      pwdRules: [(v) => !!v || this.$t("signIn.pwEmptyRules")],
      phone: null,
      mobileField: "",
      // login tab
      tab: null,
      items: ["password", "code"],
    };
  },
  computed: {
    ...mapGetters(AuthNamespace, [
      "getPlayerId",
      "getExternalToken",
      "getUserCredit",
      "getLoginCheck",
    ]),

    disableBtn() {
      if (this.idField == "" || this.pwdField == "") {
        return true;
      } else if (!this.$refs.form.validate()) {
        return true;
      } else {
        return false;
      }
    },

    calcUserCredit() {
      return Number(this.getUserCredit).toLocaleString();
    },
  },
  watch: {
    SignInDialog(val) {
      if (val) {
        this.idField = "";
        this.pwdField = "";
      }
    },
  },
  methods: {
    ...mapActions(AuthNamespace, {
      ACTION_AUTH_LOGIN: AuthActions.ACTION_AUTH_LOGIN,
    }),
    async handleLogin() {
      const validate = this.$refs.form.validate();

      if (validate) {
        await this.ACTION_AUTH_LOGIN({
          user_id: this.idField,
          password: this.pwdField,
        }).then(async (res) => {
          if (res !== undefined) {
            if (window.location.pathname == "/") {
              if (process.env.NODE_ENV === "local") {
                window.location.replace(
                  `${process.env.VUE_APP_XSWEB_URL}/?playerId=${this.getPlayerId}&externalToken=${this.getExternalToken}`,
                );
              } else {
                window.location.replace(res);
              }
            } else {
              window.location.reload();
              //this.$router.go(this.$router.currentRoute);
            }
          }
        });
      }
    },
    // 모달 닫기 이벤트
    closeDialog() {
      // this.$emit("closeDialog", changed);
      this.setDialog("signIn", false);
    },
  },
};
</script>
